import React, { useEffect } from "react";
import type { AdPositionEnum } from "../../../client/api";
import { InternalAdRenderer } from "../InternalAdRenderer";
import { AD_BLOCKED_PRO_EVENT, fb } from "../../../config/firebase";
import { trackAmplitude } from "../../../config/amplitude";
import { useAdSelection } from "../../../hooks/useAdSelection";
import { AdSensePositionEnum } from "../../../config/adsenseConfig";

type WebAdSlotProps = {
  type: AdPositionEnum | AdSensePositionEnum;
  className?: string;
};

export function WebAdSlot({
                            type,
                            className
                          }: WebAdSlotProps) {
  const { selectedAd, pro } = useAdSelection({
    type,
    canShowAdSense: false
  });

  useEffect(() => {
    if (!type || !pro) {
      return;
    }
    fb().logEvent(AD_BLOCKED_PRO_EVENT, { position: type });
    trackAmplitude("ad_blocked_pro", { type });
  }, [pro, type]);

  useEffect(() => {
    if (selectedAd && !pro) {
      trackAmplitude("ad_view", { type, name: selectedAd.name });
    }
  }, [selectedAd, pro, type]);

  if (!type || pro || !selectedAd) {
    return null;
  }

  return (
    <InternalAdRenderer
      ad={selectedAd}
      position={selectedAd.position}
      className={className}
    />
  );
}
